import { render, staticRenderFns } from "./PreviousOrderItem.vue?vue&type=template&id=86aa1f7a"
import script from "./PreviousOrderItem.vue?vue&type=script&lang=js"
export * from "./PreviousOrderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports